import {
  multiFactor,
  PhoneMultiFactorGenerator,
  TotpMultiFactorGenerator,
} from 'firebase/auth';

import { rememberLastUsedFactor } from './lastUsedFactor';

// Pure MFA-resolver helpers. Screens decide WHAT to render; this module owns
// HOW a multi-factor challenge is inspected and resolved.

export function getTotpHint(resolver) {
  if (!resolver || !resolver.hints) return null;
  return (
    resolver.hints.find(
      hint => hint.factorId === TotpMultiFactorGenerator.FACTOR_ID,
    ) || null
  );
}

export function getPhoneHint(resolver) {
  if (!resolver || !resolver.hints) return null;
  return (
    resolver.hints.find(
      hint => hint.factorId === PhoneMultiFactorGenerator.FACTOR_ID,
    ) || null
  );
}

export function userHasTotp(user) {
  if (!user) return false;
  return multiFactor(user).enrolledFactors.some(
    f => f.factorId === TotpMultiFactorGenerator.FACTOR_ID,
  );
}

export function userHasPhone(user) {
  if (!user) return false;
  return multiFactor(user).enrolledFactors.some(
    f => f.factorId === PhoneMultiFactorGenerator.FACTOR_ID,
  );
}

// Split out for the profile, which answers the same challenge but keeps the
// credential instead of the session tokens resolveTotpSignIn returns.
export function buildTotpAssertion(resolver, verificationCode) {
  const totpHint = getTotpHint(resolver);
  return TotpMultiFactorGenerator.assertionForSignIn(
    totpHint.uid,
    verificationCode,
  );
}

export function resolveTotpSignIn(resolver, verificationCode) {
  const multiFactorAssertion = buildTotpAssertion(resolver, verificationCode);
  return resolver.resolveSignIn(multiFactorAssertion).then(userCredential => {
    // Mirrors the SMS leg so the preference can swing back: without this writer
    // a single SMS sign-in would pin every later sign-in to SMS forever.
    rememberLastUsedFactor('totp');
    return {
      idToken: userCredential._tokenResponse.idToken,
      refreshToken: userCredential._tokenResponse.refreshToken,
    };
  });
}
